import React, { Component } from 'react';
import { withRouter, } from 'react-router-dom';
import { detailAPI } from '../../api/parl.js'
import '../../assets/css/common.css'
import MyBreadcrumb from '../../components/MyBreadcrumb.jsx'
class parlDetail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dataSource: [],
			currMeeting: '',
			currCountry: '',
		}
	}

	componentDidMount(){
		this.setState({currCountry: this.props.match.params.country, currMeeting: this.props.match.params.id}, () => {this.fetchDetail()})
	}
	
	fetchDetail = () => {
		const { currMeeting } = this.state;
		var params = { meeting_id: currMeeting }
		detailAPI('uk', params)
			.then(res => {
				var data = res.data.data
				console.log(data);
				
				this.setState({dataSource: data})
			})
	}

	render() {
		const { dataSource } = this.state;
		const contentEle = dataSource.speeches ?
			(dataSource.speeches.map((major_record, major_index) => 
				<div key={major_index}>
					<div className="minor-heading" style={{ color: '#333333', marginTop: 20 }}>主议题(Major Heading): {major_record.major_heading_name}</div>
					{major_record.first_level_paras.map((minor_record, minor_index) => 
						<>
							<div style={{textIndent: '1em', fontSize: 18, fontWeight: 'bold'}} >
							子议题(Minor Heading): {minor_record.minor_heading_name}
							</div>
							{minor_record.second_level_paras.map((content, content_index) => 
								<div key={content_index} className="main-text" style={{ color: '#333333', textIndent: '2em', fontWeight: 'bold', marginBottom: 10}}>
									发言人(Speaker): {content.speaker_name}
									{content.contents.map((para, para_index) => 
										<div key={para_index} className="main-text" style={{ color: '#333333', marginLeft: '2em', textIndent: '2em' }}>{para}</div>
									)}
								</div>
							)}
						</>
					)}
				</div>
			)) : <></>
		return (
            <div style={{ margin: '40px 15%', }}>
			<MyBreadcrumb urls={[
				{ url: '/database/parl/uk', breadcrumbName:  '英国议会' },
				{ breadcrumbName: '详情' },
			]} />
				<div className="major-heading" style={{  textAlign: 'center', color: '#333333', marginTop: 20 }}>{dataSource.date}</div>
				<div className="minor-heading" style={{ textAlign: 'center', color: '#333333', marginTop: 20 }}>{dataSource.type}</div>
				{contentEle}
			</div>
		);
	}
}

export default withRouter(parlDetail)
